import Vue from "vue";

import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./registerServiceWorker";

import "@mdi/font/css/materialdesignicons.css";
import FormGroup from "./components/FormGroup.vue";
import FormSummary from "./components/FormSummary.vue";
import JsonExcel from "vue-json-excel";
import VueCountdownTimer from "vuejs-countdown-timer";
import imageCompressor from "vue-image-compressor";
import vuetify from "./plugins/vuetify";
import VueClipboard from "vue-clipboard2";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';


require("./plugins");

Vue.config.productionTip = false;
Vue.use(imageCompressor);
Vue.use(VueCountdownTimer);
Vue.use(VueClipboard);

Vue.component("FormGroup", FormGroup);
Vue.component("FormSummary", FormSummary);
Vue.component("downloadExcel", JsonExcel);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);


new Vue({
  router,
  store,
  vuetify,
  icons: {
    iconfont: "mdi",
  },
  render: (h) => h(App),
}).$mount("#app");
